export default "__VITE_ASSET__77cccdda__"